// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"styles_wrapper__1qXGW","listWrapper":"styles_listWrapper__BGi7c","languageWrapper":"styles_languageWrapper__1oYeZ","countWrapper":"styles_countWrapper__2Oy9P"};